<ph-dialog open [heading]="dialogTitle" (ph-close)="close()">
    <ph-skeleton *ngIf="isLoading"></ph-skeleton>

    <div *ngIf="!isLoading" class="tracking-container">
        <div class="tracking-section" *ngIf="trackingNumber">
            <h4>Tracking number</h4>
            <ph-link-button trailing-icon="arrow-square-out"
                            href="https://tools.usps.com/go/TrackConfirmAction?tLabels={{trackingNumber}}"
                            target="_blank" rel="noopener">{{trackingNumber}}</ph-link-button>
        </div>

        <div *ngIf="statusUpdates && statusUpdates.length">
            <h4>Transfer timeline</h4>
            <div class="timeline-container">
                <div *ngFor="let update of statusUpdates; let last = last; trackBy: trackByStatusName"
                     class="timeline-item"
                     [class.completed]="update.completed"
                     [class.in-progress]="update.inProgress">
                    <div class="timeline-marker">
                        <div class="marker-icon">
                            <span *ngIf="update.completed && !update.inProgress" class="check-icon"><ph-icon name="check-circle" label="Completed"></ph-icon></span>
                            <div *ngIf="update.inProgress" class="in-progress-icon"></div> <!-- kitlint-allow-legacy: "in-progress-icon" is a custom timeline marker class; the lint's word-boundary match on bare "progress" is a false positive, not Bootstrap's .progress component -->
                            <div *ngIf="!update.completed && !update.inProgress" class="pending-icon"></div>
                        </div>
                        <div *ngIf="!last" class="marker-line"></div>
                    </div>
                    <div class="timeline-content">
                        <div class="timeline-status">{{update.name}}</div>
                    </div>
                    <div class="timeline-date">
                        <span *ngIf="update.eventTime" class="actual-date">
                            {{ update.eventTime | legfiDate:'MMM D' }}
                        </span>
                        <span *ngIf="update.estimatedDate" class="estimated-date">
                            Est. {{ update.estimatedDate | date:'MMM d' }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ph-dialog>
